import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'app/lang';
import Footer from 'app/modules/Layout/Footer';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import { clearPrematchMatches } from './actions';
import { PrematchDeferred } from './PrematchDeferred';

import dictionary from './PrematchPage.dictionary.json';

export const PrematchPageWS = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearPrematchMatches());
    };
  }, []);

  return (
    <>
      <Helmet>
        <meta name="description"
              content={t(dictionary.description)} />

        <title>{t(dictionary.title)}</title>
      </Helmet>

      <ErrorBoundary>
        <PrematchDeferred />
        <Footer />
      </ErrorBoundary>
    </>
  );
};
